module.exports = __webpack_public_path__ + "static/media/img3.67408c74.jpg";